// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-app: #fbfcff;
  --border-color: #ddd;
  --text-color: #888282;
  --primary-color: #ffd705;
  --primary-color-light: #ffd7051a;
  --primary-color_hover: #f7e27a;
  --secondary-color: rgb(68, 153, 223);
  --white: #ffffff;
  --error-color: rgb(255 37 37);
  --input-text-color: #888282;
  --input-placeholder: #888282;
  --disabled: #f1f6fe;
  --disabled-text: #afafaf;
}

body {
  background-color: var(--background-app);
}

::-webkit-input-placeholder,
select::placeholder,
input::placeholder {
  font-size: 16px !important;
}

:-moz-placeholder {
  font-size: 16 !important;
}

/*--for IE10 support--*/
:-ms-input-placeholder {
  font-size: 16px !important;
}

.form-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fbfcff;
  align-items: center;
}

.section-container {
  width: 60%;
}

.heading {
  padding-left: 0.8em;
  font-size: medium;
  font-weight: 400;
  margin-top: 1em;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #1d1d1b;
}

.form-rows {
  margin: auto;
}

.image-btn {
  padding: 1.5em 2.5em;
  border-radius: 10px;
  border: 1.5px solid #6e2eeb;
  background-color: var(--white);
  color: var(--text-color) !important;
}

.file-icon {
  font-size: xx-large;
  color: #6e2eeb;
}

.dimentions {
  font-size: 7px;
  color: var(--text-color) !important;
}

.form-submit {
  width: 60%;
  padding-right: 0.9em;
}

.submit-btn {
  float: right;
  margin-bottom: 1em;
  margin-top: 1em;
  padding: 0.5em 3em;
  border: 0;
  border-radius: 6px;
  background-color: var(--primary-color);
  color: var(--white);
  font-weight: Bold;
}

.submit-btn:hover {
  background-color: var(--primary-color_hover);
  box-shadow: 0 0 20px #6fc5ff50;
}

.submit-btn:active {
  background-color: var(--primary-color_hover);
}

.invalid {
  color: var(--error-color);
  margin-bottom: 0;
  font-size: 10px;
}

.uploaded-image {
  width: 200px;
  height: 150px;
  border-radius: 8px;
  border: 1px solid var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/view/generalForm.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC","sourcesContent":[":root {\n  --background-app: #fbfcff;\n  --border-color: #ddd;\n  --text-color: #888282;\n  --primary-color: #ffd705;\n  --primary-color-light: #ffd7051a;\n  --primary-color_hover: #f7e27a;\n  --secondary-color: rgb(68, 153, 223);\n  --white: #ffffff;\n  --error-color: rgb(255 37 37);\n  --input-text-color: #888282;\n  --input-placeholder: #888282;\n  --disabled: #f1f6fe;\n  --disabled-text: #afafaf;\n}\n\nbody {\n  background-color: var(--background-app);\n}\n\n::-webkit-input-placeholder,\nselect::placeholder,\ninput::placeholder {\n  font-size: 16px !important;\n}\n\n:-moz-placeholder {\n  font-size: 16 !important;\n}\n\n/*--for IE10 support--*/\n:-ms-input-placeholder {\n  font-size: 16px !important;\n}\n\n.form-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: #fbfcff;\n  align-items: center;\n}\n\n.section-container {\n  width: 60%;\n}\n\n.heading {\n  padding-left: 0.8em;\n  font-size: medium;\n  font-weight: 400;\n  margin-top: 1em;\n  line-height: 16px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #1d1d1b;\n}\n\n.form-rows {\n  margin: auto;\n}\n\n.image-btn {\n  padding: 1.5em 2.5em;\n  border-radius: 10px;\n  border: 1.5px solid #6e2eeb;\n  background-color: var(--white);\n  color: var(--text-color) !important;\n}\n\n.file-icon {\n  font-size: xx-large;\n  color: #6e2eeb;\n}\n\n.dimentions {\n  font-size: 7px;\n  color: var(--text-color) !important;\n}\n\n.form-submit {\n  width: 60%;\n  padding-right: 0.9em;\n}\n\n.submit-btn {\n  float: right;\n  margin-bottom: 1em;\n  margin-top: 1em;\n  padding: 0.5em 3em;\n  border: 0;\n  border-radius: 6px;\n  background-color: var(--primary-color);\n  color: var(--white);\n  font-weight: Bold;\n}\n\n.submit-btn:hover {\n  background-color: var(--primary-color_hover);\n  box-shadow: 0 0 20px #6fc5ff50;\n}\n\n.submit-btn:active {\n  background-color: var(--primary-color_hover);\n}\n\n.invalid {\n  color: var(--error-color);\n  margin-bottom: 0;\n  font-size: 10px;\n}\n\n.uploaded-image {\n  width: 200px;\n  height: 150px;\n  border-radius: 8px;\n  border: 1px solid var(--primary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
